import { render, staticRenderFns } from "./mianzheng-edit.vue?vue&type=template&id=f1239580&scoped=true&"
import script from "./mianzheng-edit.vue?vue&type=script&lang=js&"
export * from "./mianzheng-edit.vue?vue&type=script&lang=js&"
import style0 from "./mianzheng-edit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./mianzheng-edit.vue?vue&type=style&index=1&id=f1239580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1239580",
  null
  
)

export default component.exports